

const employeeList = ['Evan Akins', 
    'Sherick Anderson', 'Jorge Ayala', 'Muhammad Balal', 'Sherane Bell', 'Trent Brown', 'Kisha Bussell', 
    'Lavaughn Carter', 'Eric Champion', 'Christopher Daniel', 'Prosper Donkor', 'Sascha Feliciano', 'Charlotte Farley', 
    'Brett Guthrie', 'Calvin Jackson', 'Tyrekus Jackson', 'Burnetta Johnson', 'Quadrianna Johnson', 
    "Te'April Kelley", "Alexzander Lee", 'Angela Manning', 'Andre Nicholson', 'George Nix', 'Stephanie Peacock', 'Diondre Petty', 'Alfred Reed', 'Stephen Reynolds', 'Spencer Robertson', 'Tyliya Sellers', 'Jeffia Smith', 
    'Stacey Smith', 'Minerva Stodghill', 'Anca Tripp', 'Jennifer Turk', 'Alvin Wiggins', 'Rebecca Wilbanks', 'Marcus Williams', 'Racole Williams',
    'Woodrow Williams']




export default employeeList;